module.exports = __webpack_public_path__ + "static/media/position.037a34ef.svg";